import { useNavigation } from '@/hooks/useNavigation';
import { Button } from '@nextui-org/react';
import NotFound from 'Src/pages/not-found';

const ErrorPage: React.FC = () => {
  const { navigateToHome, reload } = useNavigation();

  const handleGoHome = () => {
    navigateToHome({ replace: true });
    reload();
  };

  return (
    <NotFound
      title="We're Sorry! Error Occurred"
      description={`Something went wrong on our end. Please try again later or return to the home page.`}
      action={
        <Button onClick={handleGoHome} color="primary">
          Go Back to Home
        </Button>
      }
    />
  );
};

export default ErrorPage;
